import { render, staticRenderFns } from "./InternInfoEditor.vue?vue&type=template&id=289ea270&"
import script from "./InternInfoEditor.vue?vue&type=script&lang=js&"
export * from "./InternInfoEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports